import has from 'lodash/has';

export const fieldTypes = {
    sitecoreData: 'sitecoreData',
    rounds: 'rounds',
    groups: 'groups'
};

export const dataTypes = {
    holeNumber: 'holeNumber',
    holeSrc: 'holeSrc',
    greenSrc: 'greenSrc',
    overviewText: 'overviewText',
    holeAveragePar: 'holeAveragePar',
    holePercUnder: 'holePercUnder',
    holeParPerc: 'holeParPerc',
    holePercOver: 'holePercOver',
    positionOnTheMap: 'positionOnTheMap',
    holeYardage: 'holeYardage',
};

export const getData = (data, field, property, index = undefined) => {
    if (!has(data, field)) return null;

    if (index !== undefined) {
        const model = data[field].filter((item) => (item.id === parseInt(index, 10)))[0];
        if (!model) return null;
        return model[property];
    }

    return data[field][property];
};
